import { useNavigate } from "react-router-dom";

import "components/order/style/OrderDetail.css";
import { useEffect, useImperativeHandle } from "react";

const PaymentHeader = ({
  payIndex,
  userInfo,
  basket,
  basketDeleteHandler,
  addrCheckHandler,
}) => {

  const navigate = useNavigate();

  const PackingComponent = () => {
    return (
      <ul className="delivery-info-list" data-odopt={basket.od_option}>
        <li>
          <ul>
            <li>매장주소</li>
            <li>
              {" "}
              <p>{basket.s_addr}</p>
            </li>
          </ul>
        </li>
      </ul>
    );
  };
  const DelivComponent = () => {
    return (
      <>
        <ul className="delivery-info-list" data-odopt={basket.od_option}>
          <li>
            <div className="adress_area">
              <div className="adress_area-content">
                <span>주소확인</span>
                <input
                  type="checkbox"
                  id={"address-checkbox" + payIndex}
                  name={"address-checkbox" + payIndex}
                  //onChange={(e) => addrCheckHandler(e, basket)}
                  onClick={(e) => {
                    addrCheckHandler(e, basket);
                  }}
                // checked={delFeeList[payIndex] > 0}
                />
                <label htmlFor={"address-checkbox" + payIndex} />
              </div>
              <button
                className="address-change"
                onClick={() => {
                  navigate("changeLocation");
                }}
              >
                주소변경
              </button>
            </div>
          </li>
          <li>
            <p>{userInfo.mb_addr}</p>
          </li>
        </ul>

        <ul className="phone-number-wrap">
          <li>
            <span className="phone-number">
              {userInfo.mb_phone
                .toString()
                .replace(/\B(?=(\d{4})+(?!\d))/g, "-")}
            </span>
          </li>
          <li>
            <input type="checkbox" id="safe-number2" name="safe-number" />
            <label htmlFor="safe-number2"></label>
            <span className="safe_number_check">
              안심번호 사용 (만나서 결제시 안심번호 사용 불가)
            </span>
          </li>
        </ul>
      </>
    );
  };

  return (
    <div className="delivery-info-box">
      <div className="underline"></div>
      <div className="wrap_frame">
        <div className="delivery-info">
          <div className="order_check_box">
            <div className="shop-name">
              <span className="order-title-light">{basket.s_name}</span>
              <button
                className="black-btn"
                onClick={() => {
                  basketDeleteHandler(basket.s_idx, true);
                }}
              ></button>
            </div>

            {/* <div className="chek_box_area">
              <input
                type="checkbox"
                id={"order-checkbox" + payIndex}
                name={"order-checkbox" + payIndex}
              />
              <label htmlFor={"order-checkbox" + payIndex} />
              <span>{basket.od_option == 4 ? "예약" : "주문"}하기</span>
            </div> */}
          </div>
          {basket.od_option == 6 || basket.od_option == 7 ? (
            ""
          ) : (
            <div className="order_type">
              <b>
                {basket.od_option == 1 && "포장"}
                {basket.od_option == 2 && "배달"}
                {basket.od_option == 4 && "예약"}
                {basket.od_option == 5 && "택배"}
              </b>{" "}
              정보
            </div>
          )}
          {(basket.od_option == 1 || basket.od_option == 4) && (
            <PackingComponent />
          )}
          {(basket.od_option == 2 || basket.od_option == 5) && (
            //<DelivComponent />
            <>
              <ul className="delivery-info-list" data-odopt={basket.od_option}>
                <li>
                  <div className="adress_area">
                    <div className="adress_area-content">
                      <span>주소확인</span>
                      <input
                        type="checkbox"
                        id={"address-checkbox" + payIndex}
                        name={"address-checkbox" + payIndex}
                        //onChange={(e) => addrCheckHandler(e, basket)}
                        onClick={(e) => {
                          addrCheckHandler(e, basket);
                        }}
                      // checked={delFeeList[payIndex] > 0}
                      />
                      <label htmlFor={"address-checkbox" + payIndex} />
                    </div>
                    <button
                      className="address-change"
                      onClick={() => {
                        navigate("changeLocation");
                      }}
                    >
                      주소변경
                    </button>
                  </div>
                </li>
                <li>
                  <p>{userInfo.mb_addr}</p>
                </li>
              </ul>

              <ul className="phone-number-wrap">
                <li>
                  <span className="phone-number">
                    {userInfo.mb_phone
                      .toString()
                      .replace(/\B(?=(\d{4})+(?!\d))/g, "-")}
                  </span>
                </li>
                <li>
                  <input type="checkbox" id="safe-number2" name="safe-number" />
                  <label htmlFor="safe-number2"></label>
                  <span className="safe_number_check">
                    안심번호 사용 (만나서 결제시 안심번호 사용 불가)
                  </span>
                </li>
              </ul>
            </>
          )}
        </div>
      </div>
      <div className="underline"></div>
    </div>
  );
};

export default PaymentHeader;
